import { render, staticRenderFns } from "./ApprovalActionButtons.vue?vue&type=template&id=75b9f874&"
import script from "./ApprovalActionButtons.vue?vue&type=script&lang=ts&"
export * from "./ApprovalActionButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports